// add scroll event
window.addEventListener("scroll", function () {

    //only run if element with class is on page
    var hasMovingImage = document.getElementsByClassName("spark-img");

    if (hasMovingImage.length > 0) {

        var spark = document.querySelector(".spark-img");
        var text = document.querySelector(".moving-spark").firstElementChild;
        var sparkPosition = spark.getBoundingClientRect();

        //check image position and add animation class
        if (
            sparkPosition.top >= 0 &&
            sparkPosition.bottom + window.innerHeight / 3 <= window.innerHeight
        ) {
            spark.classList.add("move-up");
        }

    }
});

// add scroll event
window.addEventListener("scroll", function () {

    //only run if element with class is on page
    var hasMovingImage = document.getElementsByClassName("spark-img-2");

    if (hasMovingImage.length > 0) {

        var spark = document.querySelector(".spark-img-2");
        var text = document.querySelector(".moving-spark").firstElementChild;
        var sparkPosition = spark.getBoundingClientRect();

        //check image position and add animation class
        if (
            sparkPosition.top >= 0 &&
            sparkPosition.bottom + window.innerHeight / 3 <= window.innerHeight
        ) {
            spark.classList.add("move-up");
        }

    }
});